import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'
import { Card as CardBase } from '@chilecompra/react-kit/components'

export const Root = styled(ContainerBase)`
  &.MuiContainer-root {
    margin: 35px auto 0;
    width: 100%;
  }
`

export const GridContainer = styled(({ height, margin, maxWidth, padding, ...props }) => (
  <GridBase container {...props} />
))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, textAlign, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: bold;
  line-height: 32px;
  margin: 0;
  padding: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  padding: 0;
`

export const Card = styled(CardBase)`
  &.MuiPaper-root div {
    text-align: center;
  }

  &.MuiPaper-root * {
    cursor: default;
  }
`

export const Info = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  text-align: right;
`

export const Italic = styled('span')`
  font-style: italic;
`

export const Strong = styled('strong')``

export const LinkAnchor = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  text-decoration: underline;
`

export const LinkSpan = styled('span')`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  text-decoration: underline;
`

export const List = styled('ul')``

export const ListItem = styled('li')`
  margin: 0 0 15px;
`
